/* tslint:disabled */
/* eslint-disable */
/**
 * Report Manager
 * The service allows to request reports, download, update and delete them.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum OrderByEnum {
  Desc = 'DESC',
  Asc = 'ASC'
}

export function OrderByEnumFromJSON(json: any): OrderByEnum {
  return json as OrderByEnum
}

export function OrderByEnumToJSON(value?: OrderByEnum): any {
  return value as any
}
